<template>
  <div class="w-100 flex flex-column items-center bg-near-white">
    <h1 class="green"><span class="green">Vue</span><span class="blue">tter</span></h1>
    <img src="../assets/vue-fire.png" alt="Vue + Firebase" class="w-10-l w-40 mt2 mb4">
    <p class="lh-copy f5 pa3 w-100 w-40-l tj mb4 pb4">This is a twitter-like mini app I built using <a href="https://vuejs.org" target="blank" class="green b no-underline">Vue.js</a> as the front-end framework and <a href="https://firebase.google.com/" target="blank" class="green b no-underline">Google's Firebase</a> for the backend database. A name will be auto generated each time a user posts something, and we can validate that the message is not empty or exceeds 140 characters. What's also cool about it is that it's totally reactive thanks to <span class="b">Firebase's Realtime Database</span> and <span class="b">reactivity on Vue</span>, which means that you can open this site in 2 different devices and make a post and see that it will be automatically updated on both screens without the need to refresh. <br> <br> Try it out! Leave a message so the world knows what you think!</p>
    <hr class="w-80 w-40-l bb bw1 b--black-10">
    <form class="pa3 black-80 w-30-l mb4 mt4 f-avenir">
      <div>
        <label for="comment" class="f6 b db mb2 fl green">What's on your mind? <i class="fas fa-circle-notch fa-spin purple" v-if="tweeting"></i></label><small :class="[characters > 140 ? 'red' : 'moon-gray']" class="fr">{{ characters }} characters</small>
        <textarea id="comment" name="comment" class="db border-box hover-black w-100 ba b--black-20 pa2 br2 mb2" aria-describedby="comment-desc" rows="3" v-model="post" @keyup.ctrl.enter="tweet" @keyup="error = ''"></textarea>
      </div>
      <span @click="showEmojiSelector = !showEmojiSelector "><i class="pointer dim fl" :class="[showEmojiSelector ? 'fas fa-times' : 'far fa-smile']"></i></span>
      <small class="fl red mb2 mt1 ml2">{{ error }}</small>
      <button class="pr3 pl3 pt2 pb2 white b fr bw0 br2 pointer bg-animate hover-bg-blue grow" @click.prevent="tweet" :disabled="characters < 1" :class="[characters < 1 ? 'bg-moon-gray' : 'bg-green']">Post</button>
      <small class="moon-gray fr pa2 dn db-ns">Ctrl+Enter to send...</small>
      <picker v-show="showEmojiSelector" @select="addEmoji" class="absolute ml4" set="google" title="Choose Emoji" style="z-index:100"/>
    </form>
    <div class="w-50-l w-100 pa3 f-avenir">
      <h5 class="f6 tl mb0 mt0 moon-gray mb3 i">What's new... <small class="fr">{{ posts.length }} posts</small></h5>
      <div v-if="posts.length == 0">
          <i class="fas fa-circle-notch mt4 fa-spin green fa-2x"></i>
          <h3 class="f3 moon-gray mt4">No posts</h3>
      </div>
      <ul class="list tl mt1 o-scroll pa2 pt0 bb bw1 b--silver br3 h-50" style="min-height:50vh">
        <tweet-component v-for="(tweet, index) in timeline" :key="index" :keep="index < timeline.length - 1" :tweet="tweet" @removeTweet="removeTweet(tweet)"></tweet-component>
      </ul>
    </div>
  </div>
</template>

<script>
import Firebase from 'firebase'
import Moment from 'moment'
import TweetComponent from './tweet-component'
import Axios from 'axios'
import { Picker } from 'emoji-mart-vue'

let config = {
  apiKey: 'AIzaSyAfiUsHkzvtXG9BOEhqLc6C5-8gT3nXZBw',
  authDomain: 'luis-camero.firebaseapp.com',
  databaseURL: 'https://luis-camero.firebaseio.com',
  projectId: 'luis-camero',
  storageBucket: 'luis-camero.appspot.com',
  messagingSenderId: '1031117780486'
}

let app = Firebase.initializeApp(config)

let db = app.database()

let postsRef = db.ref('posts')

function ucfirst (string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export default {
  name: 'TwitterClone',
  firebase: {
    posts: postsRef
  },
  components: {
    TweetComponent,
    Picker
  },
  data () {
    return {
      showEmojiSelector: false,
      post: '',
      error: '',
      tweeting: false
    }
  },
  computed: {
    characters: function () {
      return this.post.length
    },
    timeline: function () {
      return this.posts.slice(0).reverse()
    },
    limitReached: function () {
      return this.posts.length === 15
    }
  },
  methods: {
    addEmoji: function (emoji) {
      console.log(emoji)
      this.post = this.post + ' ' + emoji.native
    },
    tweet: function () {
      if (this.limitReached) {
        this.error = '15 posts limit reached, consider deleting some'
      } else if (this.characters <= 140 && this.post.trim().length > 0) {
        this.tweeting = true
        let randomUser = Axios.get('https://randomuser.me/api/')
          .then((response) => {
            return ucfirst(response.data.results[0].name.first) + ' ' + ucfirst(response.data.results[0].name.last)
          }).catch((error) => {
            console.log(error)
            return 'Luis Camero'
          })
        randomUser.then(author => {
          console.log(author)
          postsRef.push({
            'author': author,
            'content': this.post.trim(),
            'created': Moment(new Date()).format()
          })
          this.post = ''
          this.error = ''
          this.tweeting = false
          this.showEmojiSelector = false
        })
      } else {
        this.error = 'Sorry! Message cannot be empty or longer than 140 characters'
      }
    },
    removeTweet: function (tweet) {
      postsRef.child(tweet['.key']).remove()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.f-avenir {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
.h-50 {
  max-height: 50vh;
}
textarea {
   resize: none;
}
.break-p {
  word-break: break-word;
}
.list-enter-active, .list-leave-active {
  transition: all 1s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-item {
  display: inline-block;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Vuetter.vue